var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 15,
    viewBox: "0 0 10 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.03794 3.8274C7.03794 4.94882 6.13886 5.84327 5.04778 5.84327C3.9567 5.84327 3.05762 4.94882 3.05762 3.8274C3.05762 2.70597 3.9567 1.81152 5.04778 1.81152C6.13886 1.81152 7.03794 2.70597 7.03794 3.8274Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.50293 11.2691C1.50293 10.1196 2.03517 9.0976 2.86329 8.43879C2.95704 8.49536 3.05902 8.55488 3.16662 8.61467C3.41411 8.75218 3.70757 8.9002 4.0095 9.01615C4.29544 9.12596 4.66696 9.23811 5.04798 9.23811C5.42953 9.23811 5.80237 9.12386 6.08736 9.01356C6.38936 8.89666 6.68394 8.7475 6.93277 8.60892C7.04433 8.54679 7.14999 8.48493 7.24683 8.42634C8.08391 9.08466 8.62293 10.1123 8.62293 11.2691C8.62293 12.9032 8.17668 13.3636 7.80568 13.5675C7.55857 13.7033 7.21658 13.7959 6.73453 13.846C6.25039 13.8963 5.70529 13.8974 5.06293 13.8974C4.42057 13.8974 3.87547 13.8963 3.39133 13.846C2.90928 13.7959 2.56729 13.7033 2.32018 13.5675C1.94918 13.3636 1.50293 12.9032 1.50293 11.2691Z",
    stroke: "white",
    strokeWidth: 2
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user.dae4631e.svg";
export { ForwardRef as ReactComponent };